<template>
  <Dialog
    :visible.sync="visible"
    :containerStyle="{ width: $isMobile() ? '95vw' : '80vw', height: '80vh' }"
    :contentStyle="{ height: '100%' }"
    :maximizable="true"
    :modal="true"
    :header="dialogHeader"
    @hide="onHide"
  >
    <ImportedProducts
      v-if="equipament"
      :id="equipament.id"
      :equipament="equipament"
      :show="visible"
    />
    <template #footer>
      <Button
        label="Fechar"
        icon="pi pi-times"
        class="p-button-sm p-button-danger"
        @click="onHide"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import ImportedProducts from "./ImportedProducts.vue";

export default {
  name: "EquipmentProductsDialog",
  components: {
    Dialog,
    Button,
    ImportedProducts,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    equipament: {
      type: Object,
      default: null,
    },
  },
  computed: {
    dialogHeader() {
      if (!this.equipament) return "Produtos do Equipamento";
      return `Produtos do Equipamento - ${this.equipament.model_name} (${this.equipament.model_code})`;
    },
  },
  deactivated() {
    this.onHide();
    document.body.classList.remove('p-overflow-hidden');
  },
  beforeDestroy() {
    document.body.classList.remove('p-overflow-hidden');
  },
  methods: {
    onHide() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>
